import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import { map, Observable, Subscription, switchMap, tap} from 'rxjs';
import { NativeServiceApiProvider } from 'src/app/services/native-api-provider.service';
import { SpinnerService } from 'src/app/utils/services/spinner.service';
import { defaultIfEmpty, take } from 'rxjs/operators';
import {FilterDefinition} from 'src/app/model/CourseFilters';
import {BookListEntry} from '../../model/v3/drm';

@Component({
    selector: 'app-book-list',
    templateUrl: './book-list.component.html',
    styleUrls: ['./book-list.component.scss'],
    standalone: false
})
export class BookListComponent implements OnInit, OnDestroy, AfterViewInit {

  chosenCourse: FilterDefinition
  allEntries: BookListEntry[];
  entries: BookListEntry[];
  private BooksRefreshFrequency = 1000 * 60 * 15;
  private updateSubscription: Subscription;
  private refreshSubscription: Subscription;
  private initializeDataSubscription: Subscription;

  constructor(
    private provider: NativeServiceApiProvider,
    private spinner: SpinnerService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.refreshSubscription = this.provider
      .books()
      .pipe(
        take(1),
        map((api) => api.subscribeForRefreshingEvents()),
        switchMap((taskProgressEmitter) => taskProgressEmitter),
        switchMap((observable) => this.spinner.trace(observable))
      )
      .subscribe();

    this.updateSubscription = this.provider
      .books()
      .pipe(
        switchMap((api) => api.listenForDataUpdates()),
        defaultIfEmpty('anything'),
        switchMap((_) => this.loadData())
      )
      .subscribe();

    this.initializeDataSubscription = this.provider
      .books()
      .pipe(
        switchMap((api) =>
          api
            .refreshData(this.BooksRefreshFrequency)
            .pipe(switchMap((_) => {
              return this.loadData()
            }))
        )
      )
      .subscribe();
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  bookTracker(index: number, entry: BookListEntry): number {
    return entry.share.product.id;
  }

  ngOnDestroy(): void {
    this.updateSubscription.unsubscribe();
    this.refreshSubscription.unsubscribe();
    this.initializeDataSubscription.unsubscribe();
  }

  filterEbooks(language: FilterDefinition) {
    this.entries = this.allEntries?.filter(
      (entry) => {
        let categories = entry.share.product.categories
        return categories && categories.includes(language.category) || language.category == ''
      }
    );
  }

  loadData(): Observable<BookListEntry[]> {
    return this.spinner.trace<BookListEntry[]>(
      this.loadEntries().pipe(
        map((entries) => this.sortEntries(entries)),
        tap((entries) => {
          this.allEntries = entries;
          this.filterEbooks(this.chosenCourse);
        })
      )
    )
  }

  private loadEntries(): Observable<BookListEntry[]> {
    return this.provider.booksV3().pipe(
      switchMap((api) => api.getProducts()),
      map((entries) => entries.filter((entry) => entry.hasProduct))
    )
  }

  refreshData() {
    this.spinner
      .trace(this.provider.books().pipe(switchMap((api) => api.refreshData(0))))
      .subscribe();
  }

  sortEntries(entries: BookListEntry[]) {
    return entries.sort((a, b) => a.share.product.order - b.share.product.order);
  }

  isActive(filter: FilterDefinition) {
    return filter && this.chosenCourse && filter.code === this.chosenCourse?.code;
  }

  getLanguageTranslation(lang: FilterDefinition) {
    return "EBOOKS.FILTER_LANGS." + lang?.translationCode
  }

  setChosenCourse(lang: FilterDefinition) {
    this.chosenCourse = lang
    this.filterEbooks(this.chosenCourse);
  }
}
